<template>
  <div>
    <div id="quickviewDefault" class="quickview is-header-align" :class="{'is-active': active}">
      <header class="quickview-header is-border-bottom">
        <h1 class="title is-uppercase">
          <!-- <span v-if="faIcon" class="picto"><span class="is-border has-bg-light"><i :class="[faIcon]"></i></span></span> -->
          {{title}}
        </h1>
        <div v-if="hasbutton">
          <button class="button is-dark is-radius-large is-size-7" @click="buttonAction">
            <span class="icon is-small is-margin-right-small"><i class="fas" :class="buttonIcon"></i></span>
            <span>{{buttonTitle}}</span>
          </button>
        </div>
        <a class="picto" @click="close" v-else>
          <span class="has-bg-white">
            <i class="fal fa-times"></i>
          </span>
        </a>
      </header>
      <div class="quickview-body" :class="{'has-bg-light' : mode === 'NEW_NOTE'}">
        <component v-if="mode"
                   :is="currentComponent"
                   ref="innerComponent"
                   :event="params.event"
                   :params="params"
                   :source="params.source"
                   :default-title="params.defaultTitle"
                   :contact="params.contact"
                   :source-address="params.address"
                   :mode="params.mode"
                   :contact-seller="params.seller"
                   :initial-date="params.date"
                   :initial-contact="params.contact"
                   :excludes="params.excludes"
                   :includes="params.includes"
                   :show-seller-select="params.showSellerSelect"
                   :facets="params.facets"
                   :from-quickview="true"
                   @submit="submit"
                   @exported="exported"
                   class="quickview-block"
                   @iCanSubmit="val => iCanSubmit = val"
                   @isCalendarSelect="val => isCalendarSelect = val">
        </component>
      </div>
      <footer class="quickview-footer is-border-top" v-if="!isCalendarSelect">
        <button v-if="isExported && !googleLogged && mode === 'NEW_CALENDAR_ACTION'" class="button is-success is-full has-text-white is-googleAgenda" @click="makeGoogleLogin">
          <span>Connexion à votre compte google</span>
        </button>
        <button v-else @click="askSubmit" class="button is-success is-full has-text-white" :disabled="!iCanSubmit || loading">
          <span v-if="!loading">Valider</span>
          <span v-else><i class="fal fa-spin fa-spinner"></i></span>
        </button>
      </footer>
    </div>
    <div class="quickview-overlay" @click="close"></div>
  </div>
</template>

<script>
  import { GoogleMx } from '@/mixins'
  import { bus, EVENTS } from '../../services/bus/index.js'
  import ActionButton from './QuickViewActionButton'
  import EntitySelection from './EntitySelection'
  import GoogleEventSelection from './GoogleEventSelection'
  import NewGlobalEvent from './NewGlobalEvent'
  import NewReminder from './NewReminder'
  import EditReminder from './EditReminder'
  import SearchModal from './SearchModal'
  import SellerSelection from './SellerSelection'
  import ContactSelection from './ContactSelection'
  import PoleSelection from './PoleSelection'
  import NewContact from '../contact/ContactForm'
  import NewCalendarAction from './NewCalendarAction'
  import AccessForm from '../access/AccessForm'
  import OptionUpdateDateModal from './OptionUpdateDateModal'
  import ManageNotificationModal from './ManageNotificationModal'
  import GoogleExport from './GoogleExport'
  import LotSelection from './LotSelection'
  import NewNote from './NewNote'
  import NotesAdv from './NotesAdv'
  import Notes from './Notes'
  import { mapState } from 'vuex'

  const MODES = Object.freeze({
    ENTITY_SELECTION: 'ENTITY_SELECTION',
    GOOGLE_EVENT_SELECTION: 'GOOGLE_EVENT_SELECTION',
    GOOGLE_EXPORT: 'GOOGLE_EXPORT',
    NEW_EVENT: 'NEW_EVENT',
    NEW_CONTACT_SEARCH: 'NEW_CONTACT_SEARCH',
    NEW_REMINDER: 'NEW_REMINDER',
    EDIT_REMINDER: 'EDIT_REMINDER',
    SELLER_SELECTION: 'SELLER_SELECTION',
    CONTACT_SELECTION: 'CONTACT_SELECTION',
    POLE_SELECTION: 'POLE_SELECTION',
    NEW_CONTACT: 'NEW_CONTACT',
    EDIT_ACCESS: 'EDIT_ACCESS',
    OPTION_UPDATE_DATE: 'OPTION_UPDATE_DATE',
    MANAGE_NOTIFICATION: 'MANAGE_NOTIFICATION',
    LOT_SELECTION: 'LOT_SELECTION',
    NEW_NOTE: 'NEW_NOTE',
    NEW_CALENDAR_ACTION: 'NEW_CALENDAR_ACTION',
    NOTES: 'NOTES',
    NOTES_ADV: 'NOTES_ADV'
  })

  export default {
    name: 'QuickView',
    components: {
      EntitySelection,
      GoogleEventSelection,
      ContactSelection,
      PoleSelection,
      NewGlobalEvent,
      SearchModal,
      NewReminder,
      EditReminder,
      SellerSelection,
      NewContact,
      AccessForm,
      OptionUpdateDateModal,
      ManageNotificationModal,
      GoogleExport,
      LotSelection,
      NewCalendarAction,
      NewNote,
      Notes,
      NotesAdv
    },
    data () {
      return {
        isExported: false,
        iCanSubmit: true,
        isCalendarSelect: false,
        MODES: MODES,
        active: false,
        results: {},
        loading: false,
        mode: null,
        params: null
      }
    },
    mixins: [ActionButton, GoogleMx],
    watch: {
      quickview ({mode = null, params = null, results = null}) {
        if (mode && !results) {
          this.open({mode, params})
        } else {
          this.close()
        }
      }
    },
    computed: {
      ...mapState(['quickview', 'googleLogged']),
      title () {
        let titles = {
          [MODES.ENTITY_SELECTION]: 'Ajouter une entrée',
          [MODES.GOOGLE_EVENT_SELECTION]: 'IMPORT ÉVÈNEMENTS GOOGLE',
          [MODES.GOOGLE_EXPORT]: 'Export d\'événements vers Google',
          [MODES.NEW_EVENT]: 'Création d\'une annonce',
          [MODES.NEW_CONTACT_SEARCH]: 'Critères de recherche',
          [MODES.NEW_REMINDER]: 'Création d\'un rappel',
          [MODES.EDIT_REMINDER]: 'Modification d\'un rappel',
          [MODES.SELLER_SELECTION]: 'Sélection d\'un utilisateur',
          [MODES.CONTACT_SELECTION]: 'Sélection d\'un contact',
          [MODES.POLE_SELECTION]: 'Sélection d\'un pôle',
          [MODES.NEW_CONTACT]: 'Création d\'un contact',
          [MODES.EDIT_ACCESS]: 'Configuration d\'un mandat',
          [MODES.OPTION_UPDATE_DATE]: 'Modifier la date de fin d\'une option',
          [MODES.MANAGE_NOTIFICATION]: 'Gestion des notifications',
          [MODES.LOT_SELECTION]: 'Lots du programme',
          [MODES.NEW_NOTE]: 'Note',
          [MODES.NOTES]: 'Note(s) de suivi',
          [MODES.NEW_CALENDAR_ACTION]: 'nouvelle action',
          [MODES.NOTES_ADV]: 'Note(s) de suivi'
        }
        return titles[this.mode]
      },
      faIcon () {
        let icons = {
          [MODES.ENTITY_SELECTION]: 'fal fa-user-plus',
          [MODES.GOOGLE_EVENT_SELECTION]: 'fab fa-google',
          [MODES.GOOGLE_EXPORT]: 'fab fa-google',
          [MODES.NEW_EVENT]: 'fal fa-newspaper',
          [MODES.NEW_CONTACT_SEARCH]: 'fal fa-search',
          [MODES.NEW_REMINDER]: 'fal fa-alarm-clock',
          [MODES.EDIT_REMINDER]: 'fal fa-alarm-clock',
          [MODES.SELLER_SELECTION]: 'fal fa-user-plus',
          [MODES.CONTACT_SELECTION]: 'fal fa-user-plus',
          [MODES.POLE_SELECTION]: 'fal fa-user-plus',
          [MODES.NEW_CONTACT]: 'fal fa-user-plus',
          [MODES.EDIT_ACCESS]: 'fal fa-pencil',
          [MODES.OPTION_UPDATE_DATE]: 'fal fa-pencil',
          [MODES.MANAGE_NOTIFICATION]: 'fal fa-pencil',
          [MODES.LOT_SELECTION]: 'fal fa-user-plus',
          [MODES.NEW_NOTE]: 'fa-comment-alt',
          [MODES.NOTES]: 'fa-comment-alt',
          [MODES.NOTES_ADV]: 'fa-comment-alt'
        }
        return icons[this.mode]
      },
      currentComponent () {
        const components = {
          [MODES.ENTITY_SELECTION]: 'EntitySelection',
          [MODES.GOOGLE_EVENT_SELECTION]: 'GoogleEventSelection',
          [MODES.GOOGLE_EXPORT]: 'GoogleExport',
          [MODES.NEW_EVENT]: 'NewGlobalEvent',
          [MODES.NEW_CONTACT_SEARCH]: 'SearchModal',
          [MODES.NEW_REMINDER]: 'NewReminder',
          [MODES.EDIT_REMINDER]: 'EditReminder',
          [MODES.SELLER_SELECTION]: 'SellerSelection',
          [MODES.CONTACT_SELECTION]: 'ContactSelection',
          [MODES.POLE_SELECTION]: 'PoleSelection',
          [MODES.NEW_CONTACT]: 'NewContact',
          [MODES.EDIT_ACCESS]: 'AccessForm',
          [MODES.OPTION_UPDATE_DATE]: 'OptionUpdateDateModal',
          [MODES.MANAGE_NOTIFICATION]: 'ManageNotificationModal',
          [MODES.NEW_CALENDAR_ACTION]: 'NewCalendarAction',
          [MODES.LOT_SELECTION]: 'LotSelection',
          [MODES.NEW_NOTE]: 'NewNote',
          [MODES.NOTES]: 'Notes',
          [MODES.NOTES_ADV]: 'NotesAdv'
        }
        return components[this.mode]
      },
      hasbutton () {
        let buttons = {
          [MODES.NOTES]: true,
          [MODES.NOTES_ADV]: true
        }
        return buttons[this.mode]
      },
      buttonTitle () {
        let titles = {
          [MODES.NOTES]: 'Ajouter note',
          [MODES.NOTES_ADV]: 'Ajouter note'
        }
        return titles[this.mode]
      },
      buttonIcon () {
        let titles = {
          [MODES.NOTES]: 'fa-pen-alt',
          [MODES.NOTES_ADV]: 'fa-pen-alt'
        }
        return titles[this.mode]
      },
      buttonAction () {
        let actions = {
          [MODES.NOTES]: this.newNote,
          [MODES.NOTES_ADV]: this.newNote
        }
        if (this.mode in actions) {
          return actions[this.mode]
        } else return () => {}
      }
    },
    methods: {
      exported (val) {
        this.isExported = val
      },
      askSubmit () {
        if (this.$refs && this.$refs.innerComponent) {
          this.$refs.innerComponent.submit()
        }
      },
      submit (results) {
        this.$store.commit('setQuickview', {mode: this.mode, params: this.params, results: results})
        this.close()
      },
      open ({mode, params}) {
        this.mode = mode
        this.params = Object.assign({}, params)
        this.active = true
      },
      close () {
        this.mode = null
        this.params = null
        this.active = false
        this.iCanSubmit = true
        this.isCalendarSelect = false
      }
    },
    mounted () {
      bus.$on(EVENTS.LOADING, (v) => {
        if (v) this.loading = true
        else this.loading = false
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/QuickView.vue